<template>
  <div>
    <v-row>
      <v-col>

        <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
          <v-breadcrumbs-item v-for="item in navSettingsOptions" :key="item.index">
            <span
              class="text-breadcum-settings"
              :class='{
                "cursor-pointer":item.index===2
              }'
              @click='() => {if (item.index === 2) changeType("customFieldsTable")}'>
              {{ item.text }}
              <v-icon style="font-size: 1.2rem">mdi-chevron-right</v-icon>
            </span>
          </v-breadcrumbs-item>
        </v-breadcrumbs>

      </v-col>
    </v-row>
    <div class="home-content">
      <component
        v-if='customField'
        :is='addingType'
        :isEdit='true'
        :editId='editNumber'
        :preloadedItem='customField'
        :touch='"settingView"'
        @changeItemProperty='(name, value) => {customField[name] = value}'
        @exit='changeType("customFieldsTable")'/>
    </div>
  </div>
</template>

<script>
import { fieldsNamesFromBE } from '@/utils/customFields'
import customFieldService from '@/services/customField.js'
import smallTextBox from '@/components/customFields/smallTextBox'
import largeTextBox from '@/components/customFields/largeTextBox'
import roundNumber from '@/components/customFields/roundNumber'
import decimalNumber from '@/components/customFields/decimalNumber'
import phoneNumber from '@/components/customFields/phoneNumber'
import email from '@/components/customFields/email'
import webLink from '@/components/customFields/webLink'
import dateField from '@/components/customFields/dateField'
import checkBox from '@/components/customFields/checkBox'
import dropDown from '@/components/customFields/dropDown'
export default {
  name: 'customFieldsEdit',
  props: {
    editNumber: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      addingType: 'smallTextBox',
      customField: null,
      navSettingsOptions: [
        {
          index: 2,
          text: 'Custom Fields'
        },
        {
          index: 3,
          text: 'Edit Custom Field'
        }
      ]
    }
  },
  components: {
    smallTextBox,
    largeTextBox,
    roundNumber,
    decimalNumber,
    phoneNumber,
    email,
    webLink,
    dateField,
    checkBox,
    dropDown
  },
  methods: {
    changeType(type) {
      this.$emit('changeType', type, null)
    }
  },
  async created() {
    const response = await customFieldService.getCustomField({ id: this.editNumber })
    if (response?.data?.error?.type !== 200 || !response?.data?.data) {
      this.$store.dispatch('showSubmitFormErrorPopup', {
        title: 'Error to edit the Custom Field',
        message: response.data.error.message
      })
      return
    }

    this.customField = response.data.data
    this.customField.applicableToAll = (this.customField.applyTo === 'ALL_ITEMS')

    if (this.customField.type === 'BOOLEAN') {
      this.customField.defaultValue = (String(this.customField.defaultValue).toUpperCase() === 'TRUE')
    }

    if (this.customField.type === 'ARRAY') {
      this.customField.customFieldArrayValues.forEach(cfav => {
        cfav.isAsDefault = (String(this.customField.defaultValue) === String(cfav.id))
      })
    }
    this.addingType = fieldsNamesFromBE.get(this.customField.fieldType).name
  }
}
</script>
